import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-r-form',
  templateUrl: './r-form.component.html',
  styleUrls: ['./r-form.component.scss']
})
export class RFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
